import {
    DEFAULT_ERROR,
    thousands,
    floats,
    percent,
    round,
    toRoman,
    toArabic,
    floatToFixed,
    percentFloatToFixed,
} from './format_number'

import {
    daysSinceDate,
    formatDateAgoWith,
    getShiftedIsoString,
    getTimeSinceTimestamp,
    isDateAfter,
    isoToFormattedLocalDate,
    isoToFormattedLocalFullDate,
    isoToFormattedLocalDateTime,
    isoToFormattedLocalTime,
    unixToFormattedLocalDate,
    unixToFormattedLocalDateTime,
    unixToFormattedLocalTime,
} from './datetime'

import { isChineseRealm } from './realm.js'
import { isChineseLanguage } from './locale.js'

import {
    sendCommand,
    getToken1,
    userContextMenu,
    clanPlayersOnlineStatus,
    playerFriendsOnlineStatus,
    defaultWoTClientMessageHandler,
    blinkTaskbar,
    addVehicleToComparison,
    openExternalBrowser,
    playSound,
    sendButtonClickSoundCommand,
    sendCancelClickSoundCommand,
    sendClickSoundCommand,
    sendHoverSoundCommand,
    sendSelectClickSoundCommand,
    sendTabClickSoundCommand,
    sendNotification,
    strongholdBuildingUpgraded,
    sendErrorNotification,
    openWindow,
    closeWindow,
    openBrowser,
    openStrongholdsBattleRoom,
    closeLeaderboard,
    strongholdsBattleChosen,
    openHangar,
    joinToStrongholdsBattleOnOtherPeriphery,
    openVehiclePreview,
    openVehicleResearch,
    openVehicleSell,
    openTechTree,
} from './web_to_client'

export const helpers = {
    DEFAULT_ERROR,
    thousands,
    floats,
    percent,
    round,
    toRoman,
    toArabic,
    floatToFixed,
    percentFloatToFixed,

    daysSinceDate,
    formatDateAgoWith,
    getShiftedIsoString,
    getTimeSinceTimestamp,
    isDateAfter,
    isoToFormattedLocalDate,
    isoToFormattedLocalFullDate,
    isoToFormattedLocalDateTime,
    isoToFormattedLocalTime,
    unixToFormattedLocalDate,
    unixToFormattedLocalDateTime,
    unixToFormattedLocalTime,

    sendCommand,
    getToken1,
    userContextMenu,
    clanPlayersOnlineStatus,
    playerFriendsOnlineStatus,
    defaultWoTClientMessageHandler,
    blinkTaskbar,
    addVehicleToComparison,
    openExternalBrowser,
    playSound,
    sendButtonClickSoundCommand,
    sendCancelClickSoundCommand,
    sendClickSoundCommand,
    sendHoverSoundCommand,
    sendSelectClickSoundCommand,
    sendTabClickSoundCommand,
    sendNotification,
    strongholdBuildingUpgraded,
    sendErrorNotification,
    openWindow,
    closeWindow,
    openBrowser,
    openStrongholdsBattleRoom,
    closeLeaderboard,
    strongholdsBattleChosen,
    openHangar,
    joinToStrongholdsBattleOnOtherPeriphery,
    openVehiclePreview,
    openVehicleResearch,
    openVehicleSell,
    openTechTree,

    isChineseRealm,
    isChineseLanguage,
}



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/helpers/index.js